// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__23niF","actionsCol":"EnrolledClinics_actionsCol__3A5_-"};